import { useMutation } from '@tanstack/react-query'

import {
  startYotiSession,
  StartYotiSessionInput,
  StartYotiSessionResponse,
} from '../../../services/yoti-service/yoti.service'

/**
 * on success the caller redirects the browser to verification_url
 */
export const useStartYotiVerification = () =>
  useMutation<StartYotiSessionResponse, unknown, StartYotiSessionInput>(input =>
    startYotiSession(input),
  )
